import { DefaultReadingPlanRecord } from '../data/DefaultReadingPlanRecord';
import IReadingPlanRecord from '../interfaces/IReadingPlanRecord';

export interface IDocumentDataMigrationService {
    readingPlanMigrationToLatest: (readingPlanRecord: IReadingPlanRecord) => IReadingPlanRecord,
    readingPlanMigrationTo6: (readingPlanRecord: IReadingPlanRecord) => IReadingPlanRecord,
    assignValuesToReference: (referenceObject: any, migrationValuesObject: any) => any
}

const DocumentDataMigrationService: IDocumentDataMigrationService = {

    // This method must run all reading plan migrations
    readingPlanMigrationToLatest: (readingPlanRecord: IReadingPlanRecord) => { 
        let record: IReadingPlanRecord = {...readingPlanRecord};

        // Migrate to version 6
        record = DocumentDataMigrationService.readingPlanMigrationTo6(record);
        
        return record;
    },

    // Migrate Reading Plan Records to Document DB version 6
    readingPlanMigrationTo6: (readingPlanRecord: IReadingPlanRecord) => {
        const record: IReadingPlanRecord = {...readingPlanRecord};

        if(readingPlanRecord.readingPlan === 'chronological-cross-reference') {
            record.readingPlan = DefaultReadingPlanRecord.readingPlan;
            record.sessionsURL = DefaultReadingPlanRecord.sessionsURL;
            record.sessionsType = DefaultReadingPlanRecord.sessionsType;
            record.readingPlanCode = DefaultReadingPlanRecord.readingPlanCode;
            record.readingPlanExtrasLink = DefaultReadingPlanRecord.readingPlanExtrasLink;
            console.log("Migrated readingPlanRecord to doc DB version 6");
        }
        
        return record;
    },

    assignValuesToReference: (referenceObject: any, migrationValuesObject: any) => {
        Object.keys(migrationValuesObject).forEach((key) => {
            referenceObject[key] = migrationValuesObject[key];
        });
    }
}

export default DocumentDataMigrationService;